<template>
  <div
    class="marker-details"
    :class="{ 'marker-details--active': isMarkerDetailsActive }"
  >
    <button class="marker-details__handle" @click="isMarkerDetailsActive = !isMarkerDetailsActive">
      <fa v-if="!isMarkerDetailsActive" :icon="['fas', 'ellipsis-h']" />
      <fa v-if="isMarkerDetailsActive" :icon="['fas', 'times']" />
    </button>
    <div class="marker-details__inner">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isMarkerDetailsActive: false
    }
  },

  methods: {
    openMenu () {
      this.isMarkerDetailsActive = true
    }
  }
}
</script>

<style lang="scss" scoped>
.marker-details {
  background: rgba(255, 255, 255, .95);
  bottom: 0;
  min-width: 180px;
  padding: 8px;
  pointer-events: all;
  position: absolute;
  right: 0;
  top: 0;
  transform: translateX(100%);
  transition: transform .2s ease-in-out;
  z-index: 260;

  &--active {
    transform: translateX(0);
  }

  &__handle {
    appearance: none;
    background: #3182ce;
    border: none;
    border-radius: 50%;
    color: #fff;
    font-size: 14px;
    height: 24px;
    left: -28px;
    position: absolute;
    top: 4px;
    width: 24px;

    &:hover {
      background: #2b6cb0;
    }
  }

  &__inner {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
  }

  label {
    font-size: 11px;
  }
}

.group-inline {
  align-items: center;
  display: flex;
  margin-bottom: 14px;

  label {
    margin: auto auto auto 0;
  }

  &__input {
    background-color: #fbfcfe;
    border: 1px solid rgba(96, 125, 159, 0.25);
    border-radius: 3px;
    box-shadow: inset 0 1px 4px -1px rgba(96, 125, 159, 0.25);
    font-size: 11px;
    margin: 0 0 0 10px;
    overflow: hidden;
    padding: 4px 5px;
  }
}

.group-block {
  align-items: center;
  display: flex;
  margin-bottom: 14px;

  label {
    margin: auto auto auto 0;
  }

  &__inputs {
    display: flex;
    flex-wrap: wrap;
    width: 152px;
  }

  &__input-wrapper {
    width: 50%;
  }

  &__input {
    background-color: #fbfcfe;
    border: 1px solid rgba(96, 125, 159, 0.25);
    border-radius: 3px;
    box-shadow: inset 0 1px 4px -1px rgba(96, 125, 159, 0.25);
    font-size: 11px;
    margin: 0;
    overflow: hidden;
    padding: 4px 5px;
    width: 100%;
  }
}

.btn-colour {
  border: 1px solid #111;
  border-radius: 3px;
  width: 22px;
  height: 22px;
}

.btn-xs {
  padding: 0.25rem 0.35rem;
  font-size: 0.75rem;
  line-height: 1.25;
  border-radius: 0.2rem;
}
</style>